const data = {
  logoPath: "/img/logo.png",
  links: [
    {
      text: "Mission",
      url: "#mission",
    },
    {
      text: "Projects",
      url: "#projects",
    },
    {
      text: "Partners",
      url: "#partners",
    },
    {
      text: "Gallery",
      url: "/gallery",
    },
  ],
};

export default data;
